import { render, staticRenderFns } from "./BusinessTravelComponent.vue?vue&type=template&id=5d2da5b5"
import script from "./BusinessTravelComponent.vue?vue&type=script&lang=js"
export * from "./BusinessTravelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports